import React from "react";

const Link4 = () => {
  return <div className="link-4">Link 4</div>;
};

export default Link4;
